(function () {
  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function init(root) {
    const track = root.querySelector("[data-track]");
    const slides = Array.from(root.querySelectorAll("[data-slide]"));
    const prevBtn = root.querySelector("[data-prev]");
    const nextBtn = root.querySelector("[data-next]");
    const dots = Array.from(root.querySelectorAll("[data-dot]"));

    if (!track || slides.length === 0) return;

    // With clones, structure is: [cloneLast, ...realSlides, cloneFirst]
    const hasClones = slides.length > dots.length;
    const firstRealTrackIndex = hasClones ? 1 : 0;
    const lastRealTrackIndex = hasClones ? slides.length - 2 : slides.length - 1;

    let raf = null;
    let scrollSettleTimer = null;

    function getClosestTrackIndexToCenter() {
      const trackRect = track.getBoundingClientRect();
      const trackCenter = trackRect.left + trackRect.width / 2;

      let bestIndex = 0;
      let bestDist = Infinity;

      slides.forEach((slide, i) => {
        const rect = slide.getBoundingClientRect();
        const slideCenter = rect.left + rect.width / 2;
        const dist = Math.abs(slideCenter - trackCenter);
        if (dist < bestDist) {
          bestDist = dist;
          bestIndex = i;
        }
      });

      return bestIndex;
    }

    function setActiveByScroll() {
      const bestIndex = getClosestTrackIndexToCenter();

      slides.forEach((s, i) => s.classList.toggle("is-active", i === bestIndex));

      // Map track index -> dot index (real slide index)
      let realIndex = bestIndex;
      if (hasClones) realIndex = bestIndex - 1;
      realIndex = clamp(realIndex, 0, dots.length - 1);

      dots.forEach((d, i) =>
        d.setAttribute("aria-current", i === realIndex ? "true" : "false")
      );

      root.dataset.activeTrackIndex = String(bestIndex);
      root.dataset.activeRealIndex = String(realIndex);

      return bestIndex;
    }

    function scrollToTrackIndex(index, behavior = "smooth") {
      index = clamp(index, 0, slides.length - 1);
      slides[index].scrollIntoView({ behavior, inline: "center", block: "nearest" });
    }

    function scrollToRealIndex(realIndex, behavior = "smooth") {
      const trackIndex = hasClones ? realIndex + 1 : realIndex;
      scrollToTrackIndex(trackIndex, behavior);
    }

    // --- Invisible looping normalization (the “no jump” trick)
    function normalizeIfOnClone() {
      if (!hasClones) return;

      const activeTrackIndex = Number(
        root.dataset.activeTrackIndex || String(firstRealTrackIndex)
      );

      // Only normalize if we're actually centered on a clone
      if (activeTrackIndex !== 0 && activeTrackIndex !== slides.length - 1) return;

      // Temporarily disable snap so the instant jump is not fought by CSS
      const prevSnap = track.style.scrollSnapType;
      track.style.scrollSnapType = "none";

      if (activeTrackIndex === 0) {
        // Leading clone -> jump to last real
        scrollToTrackIndex(lastRealTrackIndex, "auto");
      } else if (activeTrackIndex === slides.length - 1) {
        // Trailing clone -> jump to first real
        scrollToTrackIndex(firstRealTrackIndex, "auto");
      }

      // Restore snap next frame and refresh active state
      requestAnimationFrame(() => {
        track.style.scrollSnapType = prevSnap || "";
        setActiveByScroll();
      });
    }

    function onScroll() {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(setActiveByScroll);

      // Debounce: when scrolling stops, normalize clones invisibly
      if (scrollSettleTimer) clearTimeout(scrollSettleTimer);
      scrollSettleTimer = setTimeout(() => {
        setActiveByScroll();
        normalizeIfOnClone();
      }, 120);
    }

    track.addEventListener("scroll", onScroll, { passive: true });

    // Arrows
    if (prevBtn) {
      prevBtn.addEventListener("click", () => {
        const current = Number(root.dataset.activeTrackIndex || String(firstRealTrackIndex));
        scrollToTrackIndex(current - 1, "smooth");
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", () => {
        const current = Number(root.dataset.activeTrackIndex || String(firstRealTrackIndex));
        scrollToTrackIndex(current + 1, "smooth");
      });
    }

    // Dots (real slides only)
    dots.forEach((dot) => {
      dot.addEventListener("click", () => {
        const i = Number(dot.getAttribute("data-dot"));
        scrollToRealIndex(i, "smooth");
      });
    });

    // Drag/swipe
    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;

    track.addEventListener("pointerdown", (e) => {
      isDown = true;
      track.classList.add("is-dragging");
      track.setPointerCapture(e.pointerId);
      startX = e.clientX;
      startScrollLeft = track.scrollLeft;

      if (scrollSettleTimer) clearTimeout(scrollSettleTimer);
    });

    track.addEventListener("pointermove", (e) => {
      if (!isDown) return;
      const dx = e.clientX - startX;
      track.scrollLeft = startScrollLeft - dx;
    });

    function endDrag() {
      if (!isDown) return;
      isDown = false;
      track.classList.remove("is-dragging");

      // Let snap land, then normalize if needed
      setTimeout(() => {
        setActiveByScroll();
        normalizeIfOnClone();
      }, 140);
    }

    track.addEventListener("pointerup", endDrag);
    track.addEventListener("pointercancel", endDrag);
    track.addEventListener("pointerleave", endDrag);

    // Initial state: center the first REAL slide so left peek shows
    requestAnimationFrame(() => {
      const startAttr = Number(root.getAttribute("data-start-index") || String(firstRealTrackIndex));
      const startTrackIndex = hasClones
        ? clamp(startAttr, firstRealTrackIndex, lastRealTrackIndex)
        : clamp(startAttr, 0, slides.length - 1);

      const prevSnap = track.style.scrollSnapType;
      track.style.scrollSnapType = "none";
      scrollToTrackIndex(startTrackIndex, "auto");

      requestAnimationFrame(() => {
        track.style.scrollSnapType = prevSnap || "";
        setActiveByScroll();
      });
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-slideshow-v2]").forEach(init);
  });
})();